import styled from 'styled-components/macro';
import modularScale from 'styles/helpers/modular-scale';
import NoData from 'components/styled/NoData/NoData';

const NoDataPattern = styled(NoData)`
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
`;

export const StyledNoData = styled(NoDataPattern)`
  padding: ${({ theme, isSmallScreen }): string =>
    isSmallScreen ? theme.spacing.medium : theme.spacing.large};
  width: 100%;
  top: 50%;

  a {
    display: inline-block;
  }
`;

export const StyledNoPosts = styled(NoDataPattern)`
  padding: ${({ theme }): string =>
    `${theme.spacing.small} ${theme.spacing.large}`};
  top: calc(50% + 4px);

  h3 {
    font-size: ${({ isSmallScreen }): string =>
      isSmallScreen ? modularScale(1) : modularScale(2)};
    margin-bottom: 0;
  }
`;
